<template>
  <v-chip
    class="my-2"
    color="bg-gray-0"
    text-color="primary"
    @click="openMap"
  >
    <v-icon
      size="20"
      class="mr-2"
    >
      ui-icon-map-full
    </v-icon>
    <div class="text-button-small">
      {{ t('На карте', options) }}
    </div>
  </v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

const openMap = () => {
  window.open(getMapUrl(), '_blank')
}

function getMapUrl() {
  const query = []

  if (filtersStore.filters.visitLocation === 'online') {
    return commonStore.url.map
  }

  query.push(`town=${commonStore.town.translit}`)
  query.push(`speciality=${filtersStore.filters.speciality.translit}`)

  if (filtersStore.filters.gender) {
    query.push(`gender=${filtersStore.filters.gender}`)
  }

  if (filtersStore.filters.experience) {
    query.push(`experience=${filtersStore.filters.experience}`)
  }

  if (filtersStore.filters.science) {
    query.push(`science=${filtersStore.filters.science}`)
  }

  if (filtersStore.filters.category) {
    query.push(`category=${filtersStore.filters.category}`)
  }

  if (filtersStore.filters.visitLocation === 'home') {
    query.push('na_dom=true')
  }

  if (filtersStore.filters.place) {
    if (filtersStore.filters.place.isMetro) {
      query.push(`metro=${filtersStore.filters.place.translit}`)
    } else {
      query.push(`district=${filtersStore.filters.place.translit}`)
    }
  }

  if (query.length) {
    return `${commonStore.url.map}?${query.join('&')}`
  }

  return commonStore.url.map
}
</script>
